import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'edu-udo-itmc-dev-mini-book-simple-editor',
    templateUrl: './simple-editor.component.html',
    styleUrls: ['./simple-editor.component.css'],
    standalone: false
})
export class SimpleEditorComponent {

  @Input() message: string = '';
  @Output() messageChange = new EventEmitter<string>();

}
